import { render } from "./WorkflowInstances.vue?vue&type=template&id=6dee6314"
import script from "./WorkflowInstances.vue?vue&type=script&lang=js"
export * from "./WorkflowInstances.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__